import { StateParams } from "@uirouter/core";
import { TourService } from "../../../../app/tour/tour.service";

export class AtendimentoListagemController implements angular.IController {
  public contadores = {
    open: 0,
    closed: 0,
  };
  public situacaoSolicitacaoSelecionado;
  public busca;
  public buscando = false;
  public atualizando = false;
  public dados;
  public helpLink = {
    url: "https://mandaenuvemenvio.zendesk.com/hc/pt-br/articles/34308940260372-Como-acompanhar-as-solicita%C3%A7%C3%B5es-de-atendimento",
    title: "Conheça o painel de Relacionamento",
  };
  public filtros: any = {
    select: {
      title: "Select",
      options: [
        {
          name: "ticketId",
          displayName: "ID da solicitação",
          code: 0,
        },
        {
          name: "trackingCode",
          displayName: "Rastreamento",
          code: 1,
        },
        {
          name: "receiverName",
          displayName: "Nome do destinátario",
          code: 2,
        },
      ],
      isSelected: {
        name: "trackingCode",
      },
    },
    text: {
      title: "Text",
      options: {
        name: "content",
        displayName: "Pesquisar",
        code: "3",
        isText: null,
      },
    },
  };
  public newTicket;

  /*@ngInject*/ constructor(
    private AtendimentoResource,
    private $timeout,
    private $state,
    private $stateParams: StateParams,
    private $tour: TourService
  ) {}

  async carregaDados(novaBusca?) {
    if (novaBusca) {
      this.busca = novaBusca;
    }

    this.atualizando = true;

    const busca = Object.assign({}, this.busca);

    busca.sortOrder = "asc";
    if (busca.sort.startsWith("-")) {
      busca.sortOrder = "desc";
      busca.sort = busca.sort.substr(1);
    }
    busca.sortBy = busca.sort;
    delete busca.sort;

    try {
      const dados = await this.AtendimentoResource.query(busca).$promise;
      this.dados = dados.tickets;
      this.contadores[busca.status] = dados.total;
    } catch (err) {
      console.error(err);
    } finally {
      this.atualizando = false;
    }
  }

  processaFiltro(filter) {
    this.atualizando = true;

    this.AtendimentoResource.query(filter).$promise.then((resultado) => {
      this.dados = resultado.tickets;
      this.buscando = true;
      this.atualizando = false;
    });
  }

  carregaSolicitacoes() {
    this.$timeout(() => {
      this.busca.status = this.situacaoSolicitacaoSelecionado;
      this.carregaDados();
    }, 0);
  }

  limpaFiltro() {
    this.dados = null;
    this.buscando = false;
    this.carregaDados();
  }

  $onInit() {
    this.AtendimentoResource.setTotalAtendimentosAtualizados({
      updatedTicketCount: 0,
    }).$promise.then(() => {});

    this.situacaoSolicitacaoSelecionado = "open";
    this.busca = {
      sort: "-updatedAt",
      limit: 10,
      page: 1,
      status: "open",
    };

    this.carregaDados();
    this.buscando = false;

    this.newTicket = this.$stateParams.newTicket;

    if (this.$stateParams.tour) {
      this.startTour();
    }
  }

  private startTour() {
    const steps = this.$tour.makeTour([
      {
        title: "Solicitações de atendimento",
        text:
          "Entre em contato com nossa Central de Relacionamento para questões relacionadas à sua conta," +
          " encomendas, dúvidas financeiras ou temas relacionados à coleta.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            '.menu-container a[href*="/relacionamento"]'
          ),
      },
      {
        title: "Solicitações em aberto",
        text:
          "Aqui você acompanha todas as solicitações pendentes, " +
          "ou seja, que estão em análise pela Mandaê ou aguardando alguma resposta do cliente.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            '.tabs-tipos-solicitações .md-nav-item[name="open"] > button'
          ),
      },
      {
        title: "Solicitações encerradas",
        text: "Aqui são exibidos todos os tickets que foram resolvidos e finalizados nos últimos 180 dias.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            '.tabs-tipos-solicitações .md-nav-item[name="closed"] > button'
          ),
        next: {
          text: "Ir para Perfil",
          action: (ev, ref) => {
            ref.close("to_next_section");
            this.$state.go("perfil", { tour: true });
          },
        },
      },
    ]);

    this.$tour.start(steps).subscribe();
  }
}
